const API_URL = import.meta.env.VITE_BASE_URL;
const API_KEY = import.meta.env.VITE_API_KEY;
const API_URL_CTRACKER = import.meta.env.VITE_API_URL_CLAIMS_TRACKER;
const BUCKET_NAME_CLAIMS_TRACKER = import.meta.env
  .VITE_BUCKET_NAME_CLAIMS_TRACKER;
const BUCKET_REGION_CLAIMS_TRACKER = import.meta.env
  .VITE_BUCKET_REGION_CLAIMS_TRACKER;
const API_URL_DOCUMENT_TEMPLATES = import.meta.env.VITE_URL_DOCUMENT_TEMPLATES;
const HELIOS_API_URL = import.meta.env.VITE_HELIOS_API_URL;
const COGNITO_INSPECTOR_USER_POOL_ID =
  import.meta.env.VITE_COGNITO_INSPECTOR_USER_POOL_ID ?? '';
const COGNITO_INSPECTOR_CLIENT_ID =
  import.meta.env.VITE_COGNITO_INSPECTOR_CLIENT_ID ?? '';
const CPE_BASE_URL = import.meta.env.VITE_CPE_BASE_URL;
const CPE_JWT = import.meta.env.VITE_CPE_JWT;
const COGNITO_SIC_USER_POOL_ID = import.meta.env.VITE_COGNITO_USERPOOL_ID ?? '';
const COGNITO_SIC_CLIENT_ID = import.meta.env.VITE_COGNITO_CLIENT_ID ?? '';

export {
  API_URL,
  API_KEY,
  API_URL_CTRACKER,
  BUCKET_NAME_CLAIMS_TRACKER,
  BUCKET_REGION_CLAIMS_TRACKER,
  API_URL_DOCUMENT_TEMPLATES,
  HELIOS_API_URL,
  COGNITO_INSPECTOR_USER_POOL_ID,
  COGNITO_INSPECTOR_CLIENT_ID,
  CPE_BASE_URL,
  CPE_JWT,
  COGNITO_SIC_USER_POOL_ID,
  COGNITO_SIC_CLIENT_ID,
};
